module.exports = __webpack_public_path__ + "img/banner2.f5e29c37.jpg";